import type { Policy } from '@ipfabric/utils';
import { ApiTablePageView } from 'components/ApiTablePage/ApiTablePageView';
import { useApiTablePage } from 'components/ApiTablePage/useApiTablePage';
import { Button } from 'components/Button/Button';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

export const policiesApiEndpoint = '/tables/policies';

interface Props {
  onCopy: (id: Policy) => void;
  onRemove: (policy: Policy) => void;
  onEdit: (id: Policy) => void;
}

export const PoliciesTable: FC<Props> = (props) => {
  const { administrationPolicies: policiesMsg } = useLocale();

  const endpoint = useTableEndpoint({
    apiEndpoint: policiesApiEndpoint,
    alternative: (origEndpoint) => ({
      id: origEndpoint.id,
      columns: [
        '...',
        createFrontendOnlyColumn({
          key: 'action',
          disabledSort: true,
          title: policiesMsg.actionColumnTitle,
          webDependencies: ['id', 'isSystem', 'scopeType'],
          render: (rowData: Policy) => (
            <div>
              <Button
                variant='tertiary'
                accent='positive'
                icon={rowData.isSystem === false ? 'fa-pen' : 'fa-eye'}
                size='xxs'
                type='button'
                onClick={() => {
                  props.onEdit(rowData);
                }}
              />
              <Button
                variant='tertiary'
                accent='positive'
                icon='fa-copy'
                size='xxs'
                type='button'
                onClick={() => {
                  props.onCopy(rowData);
                }}
              />
              {!rowData.isSystem && (
                <Button
                  variant='tertiary'
                  icon='fa-trash-can'
                  size='xxs'
                  type='button'
                  onClick={() => {
                    props.onRemove(rowData);
                  }}
                  dataTestId='remove-policy-button'
                />
              )}
            </div>
          ),
        }),
      ],
    }),
  });

  const policiesApiTablePage = useApiTablePage({
    endpoint,
    additionalApiTableProps: {
      initialSort: { column: 'name', order: 'asc' },
    },
  });

  return <ApiTablePageView model={policiesApiTablePage} />;
};
